// components/Section.tsx
import type { ReactNode } from 'react';

import { Container } from '@/components/legacy-ui';

interface SectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

/**
 * Reusable section wrapper with title and container styling
 */
export function Section({ title, children, className }: SectionProps) {
  return (
    <div
      data-testid={`${title.toLowerCase().replace(/\s+/g, '-')}-section`}
      className={className}
    >
      <h4 className="text-chariot-text-primary mb-2 text-lg font-bold">
        {title}
      </h4>
      <Container className="p-5">{children}</Container>
    </div>
  );
}
